"use client";

import PassModal from '@/components/PassModal';
import UserColor from '@/components/icons/UserColor';
import CalendarColor from '@/components/icons/calendarColor';
import Button from '@/components/ui/Button';
import DatePicker from '@/components/ui/DatePicker';
import Modal from '@/components/ui/Modal';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import useSizeController from '@/hooks/useSizeController';
import { scrollToElementById, useSubmitHotelSearch } from '@/hooks/useSubmitHotelSearch';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";
import PassengerModal from './PassengerModal';

type ChildType = {
    name: string;
    age: string;
    lastName?: string;
};

type AdultType = {
    name: string;
    lastName: string;
};

export interface PassengersType {
    rateKey: string;
    adults: AdultType[];
    children: ChildType[];
}

export default function CheckAvailability() {

    const { innerWidth, isSmall } = useSizeController()

    const { checkInTime, hasDateChanged, hasPassChanged,
        checkOutTime, allPassengers, newRoomData,
        onSubmitHotelSearch, handleSubmitDate,
        handleValueChange, setNewRoomData, values, isSubmiting }
        = useSubmitHotelSearch()

    const [showPassModal, setShowPassModal] = useState(false);


    const passModalRef = useOutsideClick(() => {
        innerWidth > 1024 && setShowPassModal(false);
    });

    return (
        <div className="hidden flex-col  gap-3 rounded-t-xl  p-4 text-sm lg:flex">
            <DatePicker.Modal
                applyButton={<div className='w-full pb-6 pt-2 flex items-center justify-center'>
                    <button onClick={handleSubmitDate} className='text-secondary-500'>
                        Apply
                    </button>
                </div>}
                preventAutoClose
                showOneMonth={isSmall}
                onChange={handleValueChange}
                values={{ startDate: values[0], endDate: values[1] }}
                buttonProps={{ className: 'border relative border-gray-200 p-4 rounded-xl flex items-center w-full justify-between cursor-pointer' }}>


                <div className='flex items-center gap-4'>
                    <CalendarColor className='w-6' />
                    <div className="">
                        <p className="pb-1 text-xs text-gray-600">Check-in</p>
                        <p>
                            {checkInTime(false) ? <span className="text-sm font-bold text-gray-600">{checkInTime(false)}</span> :
                                <div className='w-28 h-5 rounded bg-slate-200 animate-pulse'></div>
                            }
                        </p>
                    </div>
                </div>
                <div className="">
                    <p className="pb-1 text-xs text-gray-600">Check-out</p>
                    <p>
                        {checkOutTime(false) ? <span className="text-sm font-bold text-gray-600">{checkOutTime(false)}</span> :
                            <div className='w-28 h-5 rounded bg-slate-200 animate-pulse'></div>
                        }
                    </p>
                </div>
                <FontAwesomeIcon className='text-gray-500' icon={faChevronDown} />
            </DatePicker.Modal>
            <div
                ref={passModalRef}
                onClick={(e) => {
                    e.stopPropagation()
                    setShowPassModal(true)
                }}
                className='border cursor-pointer relative border-gray-200 gap-4 p-4 rounded-xl flex items-center w-full justify-between'>
                <UserColor className='w-6' />
                <div className='grow'>
                    <p className="pb-1 text-xs text-gray-600">Travelers</p>
                    <p className='font-bold text-gray-600 text-sm'>
                        {allPassengers} Travelers
                    </p>
                </div>
                <FontAwesomeIcon className='text-gray-500' icon={faChevronDown} />
                {
                    innerWidth > 1024 ? (
                        <PassModal
                            setRoomData={setNewRoomData}
                            roomData={newRoomData}
                            showPassModal={showPassModal}
                        />
                    ) : <Modal
                        isFull
                        identifier='travelers'
                        title="Rooms and Guests"
                        onClose={() => setShowPassModal(false)}
                        show={showPassModal}
                    >
                        <div className='pb-4'>
                            <PassengerModal setRoomData={setNewRoomData} roomData={newRoomData} showPassModal={showPassModal} />
                        </div>
                        <Button
                            color='secondary'
                            radius='rounded-full'
                            onClick={() => setShowPassModal(false)}
                            className="flex w-full items-center  justify-center gap-1 "
                        >
                            <span className=" flex flex-row gap-1.5">
                                Done
                            </span>
                        </Button>
                    </Modal>}
            </div>
            <div className="w-full pt-2">
                <Button
                    disabled={!hasPassChanged && !hasDateChanged}
                    isLoading={isSubmiting}
                    color='primary'
                    radius='rounded-full'
                    onClick={() => {
                        scrollToElementById('rooms')
                        onSubmitHotelSearch()
                    }}
                    className={`w-full min-w-full px-5 py-2.5 text-white`} >
                    Check Availability
                </Button>
            </div>
        </div>
    );
}